import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { FindFaresRequest, FindFaresResponse, GetDailyFaresResponse } from '../models/fares.model';

@Injectable({ providedIn: 'root' })
export class FaresService extends BaseApiService {
  findFares(body: FindFaresRequest): Observable<FindFaresResponse> {
    // Mapea POST /fares
    return this.post<FindFaresResponse>('/fares', body);
  }

  getDailyFares(
    origin: string,
    destination: string,
    adults: number,
    children: number,
    railcard: string,
    departureDate: string,
  ): Observable<GetDailyFaresResponse> {
    const endpoint = `/fares/${origin}/${destination}/${adults}/${children}/${railcard}/${departureDate}`;
    return this.get<GetDailyFaresResponse>(endpoint);
  }
}
